<template>
    <div class="row comments_Title" v-if="commentAry && commentAry.TotalPage">
        <div class="col-md-12" style="display:none">
            <h4>留言</h4><span class="message_word">298使用規範</span>
            <div id="starBg" class="star_bg">
                <input type="radio" id="starScore1" class="score score_1" value="1" name="score">
                <a href="#starScore1" class="star star_1"><label for="starScore1">差</label></a>
                <input type="radio" id="starScore2" class="score score_2" value="2" name="score">
                <a href="#starScore2" class="star star_2"><label for="starScore2">较差</label></a>
                <input type="radio" id="starScore3" class="score score_3" value="3" name="score">
                <a href="#starScore3" class="star star_3"><label for="starScore3">普通</label></a>
                <input type="radio" id="starScore4" class="score score_4" value="4" name="score">
                <a href="#starScore4" class="star star_4"><label for="starScore4">较好</label></a>
                <input type="radio" id="starScore5" class="score score_5" value="5" name="score">
                <a href="#5" class="star star_5"><label for="starScore5">好</label></a>
            </div>
        </div>
        <div class="col-md-12" style="display:none">
            <div class="col-md-10">
                <textarea name="textarea" cols="auto" rows="3" id="textarea" class="form-control" placeholder="字數限制10字以上，300字以下"></textarea>
            </div>
            <div class="col-md-2">
                <a><div class="textarea_send">確認送出 </div></a>
            </div>
        </div>
        
        <div class="row" v-if="commentAry.TotalPage">
            <div class="col-md-12">
                <h2>評論 (<span class="comment-count">{{commentAry.TotalComment}}</span>)</h2>
                <div class="custom_select_area">
                    <div class="custom-select2" style="float:right;">
                        <div class="custom_select_word">排序</div>
                        <select name="" id="customSelect" @change="getSelect()">
                            <option value="0">選擇排序</option>
                            <option value="4">依最新</option>
                            <option value="10">依人氣</option>
                            <!-- <option value="8">依星等</option> -->
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-12">
            <div class="comment_wrap">
                <comment :comment="comment" v-for="(comment, idx) in commentAry.Comments" :key="idx" :index="''+ (((currentPage-1)*showPages)+(idx+1))"></comment>
            </div>
        </div>
        <!-- <pagination :item="comments"></pagination> -->
        <b-pagination size="md" :total-rows="commentAry.TotalComment" v-model="currentPage" :per-page="showPages" :first-text="''" :last-text="''"></b-pagination>
    </div>
</template>

<script>
import axios from 'axios'
import {API_URL, userStatus, sourceTree} from './config.js'
import user from './user.js'
import book from './book.js'
import filters from './filters.js'
import Like from './Like.vue'
import Comment from './Comment.vue'
import bPagination from 'bootstrap-vue/es/components/pagination/pagination'


const showPages = 10

export default {
  name: 'Comments',
  props: ["comments","book"],
  watch:{
      comments: function(newVal, oldVal) { // watch it
      console.log('Prop changed: ', newVal, ' | was: ', oldVal)
      console.log("commentAry",this.commentAry)
      this.commentAry = newVal
      this.currentPage = newVal.Page
    }
  },
  data () {
    return {
        showPages: showPages,
        book:this.book,
        commentAry:this.comments,
        currentPage:this.comments.Page
    }
  },
  methods: {
    ...user,
    ...book,
    goPage (page) {
        this.now = page
    },
    getSelect(){
        var menu = document.getElementById("customSelect")
        var selectItem = menu.options[menu.selectedIndex].value
        if(selectItem>0){
            this.addCommentList(this.book.BookGroupID,this.book.BookId,selectItem)
        }
    },
    addCommentList(bookGroupID,bookId,sortType,page=1){
        return new Promise((resolve, reject) => {
            var thisItem = this
            var path = {
                bookGroupID: bookGroupID
            }
            var params = {
                // bookId: bookId,
                sortType: sortType,
                page:page
            }
            axios.get(`${API_URL}/Comment/List/${this.getParams(path, false)}${this.getParams(params)}`, this.getBearerToken()).then(response => {
                thisItem.commentAry = response.data
                thisItem.currentPage = response.data.Page
            }).catch(e => {
                // console.log(e)
                // this.errors.push(e)
                alert(e.message)
            })
        })
    },
    getParams: function (params, questionMark = true) {
      let str = ''
      for (var key in params) {
        if (questionMark) {
          if (str !== '') {
            str += '&'
          }
          str += key + '=' + encodeURIComponent(params[key])
        } else {
          if (str !== '') {
            str += '/'
          }
          str += encodeURIComponent(params[key])
        }
      }
      return questionMark ? `?${str}` : `${str}`
    },
    getBearerToken: function () {
      return {
        headers: {'Authorization': 'bearer ' + sourceTree.token}
      }
    }  
  },
  filters: {
    ...filters
  },
  components: {
    bPagination,
    Comment,
    Like
  },
  mounted () {
    this.$watch('currentPage', function (value) {
        let menu = document.getElementById("customSelect")
        var selectItem
        var item
        var thisItem = this
        if(menu){
            selectItem = menu.options[menu.selectedIndex].value>0? menu.options[menu.selectedIndex].value : 4
        }

        var path = {
            bookGroupID: this.book.BookGroupID
        }
        var params = {
            // bookId: this.book.BookID,
            sortType: selectItem,
            page:value
        }
        axios.get(`${API_URL}/Comment/List/${this.getParams(path, false)}${this.getParams(params)}`, this.getBearerToken()).then(response => {
            thisItem.commentAry = response.data
        }).catch(e => {
            // console.log(e)
            // this.errors.push(e)
            alert(e.message)
        })
        // console.log(this.comments.Comments.slice(value*showPages, value*(showPages+1) ))
    })
    // console.log(this.$el)
    // if (this.item) $('[data-remodal-id=modal-'+this.item.BookID+']').remodal()
    // $('[data-remodal-id=modal-'+this.item.BookID+']').remodal()
  }
}
</script>


// WEBPACK FOOTER //
// src/Comments.vue